"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fd = exports.wd = exports.ht = exports.tm = exports.d = exports.n = exports.t = void 0;
var i18n_js_1 = __importDefault(require("i18n-js"));
var pt_BR_1 = __importDefault(require("./pt_BR"));
i18n_js_1.default.translations = {
    /* eslint-disable-next-line */
    pt_BR: pt_BR_1.default,
};
i18n_js_1.default.defaultLocale = 'pt_BR';
i18n_js_1.default.locale = 'pt_BR';
i18n_js_1.default.missingBehaviour = 'guess';
var t = function (key, params) { return i18n_js_1.default.t("strings." + (key.key ? key.key : key), key.params ? __assign(__assign({}, key.params), params) : params); };
exports.t = t;
var n = function (value, precision) {
    if (precision === void 0) { precision = 2; }
    return i18n_js_1.default.toNumber(value, { precision: precision });
};
exports.n = n;
var d = function (date, format) {
    if (format === void 0) { format = 'short'; }
    return i18n_js_1.default.toTime("date.formats." + format, date);
};
exports.d = d;
var tm = function (time) { return i18n_js_1.default.toTime('time.formats.short', time); };
exports.tm = tm;
var ht = function (time) { return i18n_js_1.default.toTime('time.formats.hour', time); };
exports.ht = ht;
var wd = function (date) { return i18n_js_1.default.toTime('date.formats.weekday', date); };
exports.wd = wd;
var fd = function (date) { return i18n_js_1.default.toTime('date.formats.full', date); };
exports.fd = fd;
